import { PermissionEnum } from '../../../common/permissions/permissions.Enum';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { getUserManagementModuleName } from './user-management.permissions';

export class UsersPermissions {
    static GroupName = `${getUserManagementModuleName()}.Users`;

    static getPermissions = getGroupPermissionFactory(UsersPermissions.GroupName);

    static Permissions = {
        Read: UsersPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: UsersPermissions.getPermissions(PermissionEnum.READ_ALL)
    };
}
